import { resolveStudentTabDestination } from "./studentTabRouting";

/**
 * @param {string} pathname
 * @param {string} search
 * @param {string} tabLabel
 * @param {import("./studentTabRouting").StudentTabRouteHints} [hints]
 * @returns {boolean}
 */
export function isCoursePestanaNavActive(pathname, search, tabLabel, hints) {
  const label = typeof tabLabel === "string" ? tabLabel.trim() : "";
  if (label.length === 0) {
    return false;
  }

  const { routeSlug, pestana } = resolveStudentTabDestination(label, hints);
  const path = typeof pathname === "string" ? pathname : "";
  const onRoute = path === `/usuario/${routeSlug}` || path.startsWith(`/usuario/${routeSlug}/`);
  if (!onRoute) {
    return false;
  }

  const params = new URLSearchParams(typeof search === "string" ? search : "");
  const currentPestana = params.get("pestana") || "";
  return currentPestana === pestana;
}
